import React from 'react';
import {LinksContainerDPC, LinksDPC, YtEmbedDPC} from "../index";

export default class DpcTabset extends React.Component {

    render() {
        if (Array.isArray(this.props.items) && this.props.items.length)
            return (
                <div id={this.props.id} className="tab-custom">
                    <div className="nav-tabs-wrapper">
                        <ul className="nav nav-tabs auto" role="tablist">
                            {
                                this.props.items.map((item, index) =>
                                    <li className="nav-item">
                                        <a role="tab" data-toggle="tab" id={`${this.props.id}Link${index}`}
                                           href={`#${this.props.id}Panel${index}`}
                                           aria-controls={`${this.props.id}Panel${index}`}
                                           aria-selected={item.iframe ? item.active ? "true" : "false" : index ? "false" : "true"}
                                           className={"nav-link" + (item.iframe ? item.active ? " active" : "" : index ? "" : " active")}
                                           dangerouslySetInnerHTML={{__html: item.title ? item.title : ''}}/>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                    <div className="tab-content">
                        {
                            this.props.items.map((item, index) =>
                                <div role="tabpanel" id={`${this.props.id}Panel${index}`}
                                     aria-labelledby={`${this.props.id}Link${index}`}
                                     className={"tab-pane fade" + (item.iframe ? item.active ? " show active" : "" : index ? "" : " show active")}>

                                    {item.iframe &&
                                    <div className="iframe-map-embed embed-responsive embed-responsive-custom">
                                        <embed
                                            src={item.iframe.uri}
                                            className="embed-responsive-item"
                                            title={item.title}
                                        >
                                        </embed>
                                    </div>
                                    }

                                    {item.img ?
                                        <>
                                            <img
                                                src={item.img.relationships?.image?.localFile?.publicURL}
                                                className="img-fluid float-left"
                                                alt={item.img.field_alt}/>
                                            <div dangerouslySetInnerHTML={{__html: item.body ? item.body : ''}}/>
                                        </>
                                        : <div dangerouslySetInnerHTML={{__html: item.body ? item.body : ''}}/>}

                                    {item.tabella &&
                                    <div className="table-responsive table table-custom"
                                         dangerouslySetInnerHTML={{__html: item.tabella}}/>}

                                    {item.video &&
                                    <div className="gallery-photo-video-embed">
                                        <YtEmbedDPC
                                            titoloSezione={item.video.field_titolo_esteso}
                                            url={item.video.field_video?.uri}
                                            descrizione={item.video.field_didascalia}
                                            classe={'px-5'}
                                        />
                                    </div>
                                    }

                                    {(item.links && Array.isArray(item.links) && item.links.length > 0) &&
                                    <LinksContainerDPC>
                                        <LinksDPC links={item.links}/>
                                    </LinksContainerDPC>
                                    }
                                </div>
                            )
                        }
                    </div>
                </div>
            );
        return ("");
    }
}
